




























import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Api from '@/api'
import BaseHeader from '@/components/layout/BaseHeader.vue'
import { STORAGE_URL } from '@/constants'

@Component({
  components: {
    BaseHeader,
    Icon
  }
})
export default class Header extends Vue {
  isNavOpen: boolean = false
  facilityLogo: string = ''
  unwatchResident: any = null

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  created () {
    this.unwatchResident = this.$watch('resident', (resident) => {
      if (resident && resident.facility && resident.facility.logo) {
        this.facilityLogo = `${STORAGE_URL}?file=${resident.facility.logo}`
      }

      if (resident && resident.facility) {
        this.unwatchResident()
      }
    }, { deep: true })
  }

  logout (): void {
    Api.logout()
    this.$router.replace({ name: 'login' })
  }

  goToResidents (): void {
    this.toggleNavOpen()
    this.$router.push({ name: 'resident-general' })
  }

  toggleNavOpen (): void {
    this.isNavOpen = !this.isNavOpen
  }

  beforeDestroy () {
    this.isNavOpen = false
  }
}
